import ArgonTypography from "components/ArgonTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React from "react";

import ArgonBox from "components/ArgonBox";
import Table from "examples/Tables/Table";
import Card from "@mui/material/Card";

// Argon Dashboard 2 MUI components

// Argon Dashboard 2 MUI examples
import Footer from "examples/Footer";

import Profile from "./parentProfile/profile";
import ActivityAttendance from "./parentProfile/activityAttendance";
import ClassManagement from "./parentProfile/classManagment";
import Communication from "./parentProfile/communication";
import FinanceInvoices from "./parentProfile/financeInvoices";
import ApnaTabs from "components/ApnaTabs/ApnaTabs";
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import axios, { baseURL } from "utils/api";
import { Chip } from "@mui/material";

function AddTutor() {
  const { id } = useParams();
  const [followUpStatus, setFollowUpStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [parent, setParent] = useState(null);
  const [activityAttendanceStatus, setActivityAttendanceStatus] = useState("error");
  const [classManagementStatus, setClassManagementStatus] = useState("error");
  const [financeInvoicesStatus, setFinanceInvoicesStatus] = useState("error");

  // Fetch parent CRM data for follow-up status
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        // Fetch both CRM and parent data in parallel
        const [crmResponse, parentResponse] = await Promise.all([
          axios.get(`${baseURL}/crm?parentId=${id}`).catch((err) => {
            console.error("Error fetching parent CRM data:", err);
            return null;
          }),
          axios.get(`${baseURL}/parent/profile/${id}`).catch((err) => {
            console.error("Error fetching parent data:", err);
            return null;
          }),
        ]);

        // Handle CRM response
        if (crmResponse && crmResponse.data) {
          console.log("CRM API response:", crmResponse.data);
          const crmEntries = crmResponse.data?.data?.crmEntries || [];
          if (crmEntries.length > 0) {
            // Priority: followUpStatus > parentStatus
            const status = crmEntries[0].followUpStatus || crmEntries[0].parentStatus;
            setFollowUpStatus(status || null);
          } else {
            setFollowUpStatus(null);
          }
        } else {
          setFollowUpStatus(null);
        }

        // Handle parent response
        if (parentResponse && parentResponse.data) {
          console.log("Parent API response:", parentResponse.data);
          if (parentResponse.data.success) {
            setParent(parentResponse.data.data);

            // Pre-fetch activity & attendance data to set status immediately
            try {
              const [studentsResponse, attendanceResponse] = await Promise.all([
                axios
                  .get(`/student?parentId=${id}`)
                  .catch(() => ({ data: { success: false, data: [] } })),
                axios
                  .get(`/attendance?studentId=all&parentId=${id}`)
                  .catch(() => ({ data: { success: false, data: [] } })),
              ]);

              const hasStudents =
                studentsResponse.data.success &&
                studentsResponse.data.data &&
                studentsResponse.data.data.length > 0;
              const hasAttendance =
                attendanceResponse.data.success &&
                attendanceResponse.data.data &&
                attendanceResponse.data.data.length > 0;

              if (hasStudents || hasAttendance) {
                setActivityAttendanceStatus("success");
              } else {
                setActivityAttendanceStatus("error");
              }
            } catch (activityError) {
              console.error("Error pre-fetching activity data:", activityError);
              setActivityAttendanceStatus("error");
            }

            // Pre-fetch class management data to set status immediately
            try {
              const classResponse = await axios.get(`/classes/sessions/all?parentId=${id}`);
              if (
                classResponse.data.success &&
                classResponse.data.data &&
                classResponse.data.data.length > 0
              ) {
                setClassManagementStatus("success");
              } else {
                setClassManagementStatus("error");
              }
            } catch (classError) {
              console.error("Error pre-fetching class data:", classError);
              setClassManagementStatus("error");
            }

            // Pre-fetch finance & invoices data to set status immediately
            try {
              const financeResponse = await axios.get(
                `/finance/get-all-raise-invoice?parentId=${id}`
              );
              if (
                financeResponse.data.success &&
                financeResponse.data.data &&
                financeResponse.data.data.length > 0
              ) {
                setFinanceInvoicesStatus("success");
              } else {
                setFinanceInvoicesStatus("error");
              }
            } catch (financeError) {
              console.error("Error pre-fetching finance data:", financeError);
              setFinanceInvoicesStatus("error");
            }
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchData();
    }
  }, [id]);

  const tabsData = [
    {
      label: "Profile",
      icon: <i className="ri-check-line"></i>,
      status: "success",
      content: <Profile />,
    },
    {
      label: "Activity & Attendance",
      icon:
        activityAttendanceStatus === "success" ? (
          <i className="ri-check-line"></i>
        ) : (
          <i className="ri-close-line"></i>
        ),
      status: activityAttendanceStatus,
      content: <ActivityAttendance parentId={id} onStatusChange={setActivityAttendanceStatus} />,
    },
    {
      label: "Class Management",
      icon:
        classManagementStatus === "success" ? (
          <i className="ri-check-line"></i>
        ) : (
          <i className="ri-close-line"></i>
        ),
      status: classManagementStatus,
      content: <ClassManagement parentId={id} onStatusChange={setClassManagementStatus} />,
    },
    {
      label: "Finance & Invoices",
      icon:
        financeInvoicesStatus === "success" ? (
          <i className="ri-check-line"></i>
        ) : (
          <i className="ri-close-line"></i>
        ),
      status: financeInvoicesStatus,
      content: <FinanceInvoices parentId={id} onStatusChange={setFinanceInvoicesStatus} />,
    },
    {
      label: "Communication",
      // icon: <i className="ri-check-line"></i>,
      // status: "success",
      content: <Communication />,
    },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <ArgonBox py={3}>
        <ArgonBox mb={3}>
          <Card>
            <ArgonBox p={3}>
              <ArgonBox display="flex" alignItems="center" justifyContent="space-between" mb={2}>
                <ArgonTypography variant="h6">Parents Profile</ArgonTypography>
                <ArgonBox display="flex" gap={1}>
                  {/* CRM Follow-up Status */}
                  {!loading &&
                    (followUpStatus ? (
                      <Chip
                        label={`Current Status: ${followUpStatus}`}
                        color="primary"
                        variant="outlined"
                        sx={{
                          fontWeight: "bold",
                          fontSize: "0.875rem",
                          borderWidth: 2,
                        }}
                      />
                    ) : (
                      <ArgonTypography variant="caption" color="error">
                        Follow-up Status not available
                      </ArgonTypography>
                    ))}
                  {/* Database Status (from parent object) */}
                  {!loading && parent && parent.status && (
                    <Chip
                      label={`DB Status: ${parent.status}`}
                      color="secondary"
                      variant="outlined"
                      sx={{
                        fontWeight: "bold",
                        fontSize: "0.875rem",
                        borderWidth: 2,
                      }}
                    />
                  )}
                </ArgonBox>
              </ArgonBox>

              <ArgonBox display="flex" justify-content="space-between" alignItems="center">
                <ApnaTabs tabsData={tabsData} />
              </ArgonBox>
            </ArgonBox>
          </Card>
        </ArgonBox>
      </ArgonBox>
      <Footer />
    </DashboardLayout>
  );
}

export default AddTutor;
